export const CONSTANT = {
    user_types: {
        client_user: 'client_user',
        agency_user: 'agency_user'
    }
}